import axios from 'axios';
import config from '../config';

const baseUrl = config.RDPMS_API_URLS;

const AUTH_SESSION_KEY = 'RDPMS_User';

const getTokenFromSession = () => {
    const raw = sessionStorage.getItem(AUTH_SESSION_KEY) || localStorage.getItem(AUTH_SESSION_KEY);
    if (!raw) return null;

    try {
        const session = JSON.parse(raw);
        return session?.token || null;
    } catch (err) {
        return null;
    }
};

const axiosInstance = axios.create({
    baseURL: baseUrl,
});

axiosInstance.interceptors.request.use((requestConfig) => {
    const token = getTokenFromSession();

    if (token) {
        requestConfig.headers.Authorization = `Bearer ${token}`;
    }

    return requestConfig;
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error.response) {
            return Promise.reject(error);
        }

        if (error.response.status === 401) {
            console.warn('Session expired ya token invalid hai');

            sessionStorage.removeItem(AUTH_SESSION_KEY);
            localStorage.removeItem(AUTH_SESSION_KEY);

            window.location.href = '/not-found';

            return new Promise(() => {});
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
